import React from "react";
import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { getRouteSeo, SITE_NAME } from "../seo/routeSeo";

export default function RouteSeo() {
  const location = useLocation();
  const seo = getRouteSeo(location.pathname);

  return (
    <Helmet prioritizeSeoTags>
      <html lang="de" />
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="robots" content={seo.robots} />
      <meta name="application-name" content={SITE_NAME} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="de_DE" />
      <meta property="og:type" content={seo.type} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:url" content={seo.canonical} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={`${SITE_NAME} Vorschau`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <link rel="canonical" href={seo.canonical} />
      {Array.isArray(seo.structuredData)
        ? seo.structuredData.map((item, index) => (
            <script key={`${location.pathname}-ld-${index}`} type="application/ld+json">
              {JSON.stringify(item)}
            </script>
          ))
        : null}
    </Helmet>
  );
}
